import { Method } from '@rxap/utilities';
import { OpenApiMethod, HttpMethods, BaseOpenApiMethod } from '../../open-api.method';

@OpenApiMethod({
  method: HttpMethods.POST,
  apiName: 'customer',
  path: '/order/paypal/complete',
  operationId: 'OrderPaypalController_complete',
  parameters: [],
})
export class OrderPaypalControllerCompleteMethod extends BaseOpenApiMethod<void> implements Method<void, void> {
  public call(): Promise<void> {
    return super.call();
  }
}
